import type { CSSProperties } from 'react';

/** Theme tokens for store-branded CTAs / selection chrome. */
export type DesignerUiTheme = {
  /** Primary CTA fill (default yellow). */
  accent?: string;
  /** Text/icon on accent buttons. */
  onAccent?: string;
  /** Selection / active outline (default rose). */
  highlight?: string;
};

const HEX_RE = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export function normalizeThemeHex(raw: string | null | undefined): string | undefined {
  if (!raw) return undefined;
  let v = String(raw).trim();
  if (!v) return undefined;
  if (!v.startsWith('#')) v = `#${v}`;
  if (!HEX_RE.test(v)) return undefined;
  if (v.length === 4) {
    const r = v[1]!;
    const g = v[2]!;
    const b = v[3]!;
    v = `#${r}${r}${g}${g}${b}${b}`;
  }
  return v.toLowerCase();
}

/** Inline CSS custom properties for `.ox-root`. */
export function uiThemeStyle(theme?: DesignerUiTheme | null): CSSProperties | undefined {
  if (!theme) return undefined;
  const accent = normalizeThemeHex(theme.accent);
  const onAccent = normalizeThemeHex(theme.onAccent);
  const highlight = normalizeThemeHex(theme.highlight);
  if (!accent && !onAccent && !highlight) return undefined;
  const style: Record<string, string> = {};
  if (accent) {
    style['--ox-accent'] = accent;
    style['--ox-yellow'] = accent;
  }
  if (onAccent) {
    style['--ox-on-accent'] = onAccent;
  }
  if (highlight) {
    style['--ox-highlight'] = highlight;
    style['--ox-red'] = highlight;
  }
  return style as CSSProperties;
}
